<template>
  <panel>
    <el-tabs v-model="activeName" @tab-click="handleClick()">
      <el-tab-pane label="即将还件" name="near"></el-tab-pane>
      <el-tab-pane label="超期未还" name="over"></el-tab-pane>
      <vxe-table
        :data="recordsCompute"
        :loading="loading"
        :cell-style="cellStyle"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        auto-resize
        :span-method="mergeMethod"
        border
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="_customerName"
          :title="$t('menu.customers')"
          min-width="100px"
        >
          <template v-slot="{ row }">
            {{ row._customerName }}

            <div class="font10" v-if="row._packageName != null">
              {{ $t("menu.packages") }}:{{ row._packageName }}
            </div>
            <div class="font10">{{ $t("menu.shops") }}:{{ row._shopName }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="type" :title="$t('text.type')" min-width="50">
          <template v-slot="{ row }">
            <div :class="'tag-type tag-type-' + row.type">
              {{ $t("itemTypes." + row.type) }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="80"
        />
        <vxe-table-column
          field="color"
          :title="$t('product.color')"
          min-width="70"
        />
        <vxe-table-column
          field="size"
          :title="$t('product.size')"
          min-width="60"
        />
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="60"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="workflowState"
          :title="$t('text.workflowState')"
          min-width="50"
        >
          <template v-slot="{ row }">
            <state-label :state="row.workflowState">
              {{ $t("rentStates." + row.workflowState) }}
            </state-label>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="50"
          fixed="right"
        >
          <template v-slot="{ row }">
            <el-button
              v-if="
                row.workflowState == 'outed' &&
                ['clean', 'rent'].includes(row.type)
              "
              slot="reference"
              type="text"
              size="mini"
              @click="inItem(row)"
              >{{ $t("action.stockIn2") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
    </el-tabs>

    <!-- 入库/完成 -->
    <el-dialog
      :title="$t('rentItem.inRemark')"
      :close-on-click-modal="false"
      :visible.sync="inDF"
      width="30%"
    >
      <el-form ref="inObjForm" :model="inObj">
        <el-form-item :prop="'remark'">
          <el-input
            size="small"
            v-model.trim="inObj.remark"
            type="textarea"
            :rows="3"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="inDoing"
          size="small"
          @click="inSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="inDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </panel>
</template>

<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Rent from "@/api/rent.js";
import RentItem from "@/api/rentItem.js";

export default {
  mixins: [page],
  data() {
    return {
      activeName: "near",
      loading: false,
      records: [],
      recordsCompute: [],
      mergeCells: [],
      finishDoing: false,
      // 入库
      inDF: false,
      inObj: {
        remark: null,
      },
      inDoing: false,
    };
  },
  created() {
    const self = this;
    self.handleClick();
  },
  methods: {
    handleClick() {
      const self = this;
      if (self.activeName == "near") {
        self.loading = true;
        Rent.workbenchNear().then(function (res) {
          if (res.status == 200) {
            self.records = res.data;
            self.recordsCompute = self.buildTableData(self.records);
            self.mergeCells = self.buildMergeCells(self.records);
          } else {
            self.sysError();
          }
          self.loading = false;
        });
      }
      if (self.activeName == "over") {
        self.loading = true;
        Rent.workbenchOver().then(function (res) {
          if (res.status == 200) {
            self.records = res.data;
            self.recordsCompute = self.buildTableData(self.records);
            self.mergeCells = self.buildMergeCells(self.records);
          } else {
            self.sysError();
          }
          self.loading = false;
        });
      }
    },

    // 入库
    inItem(row) {
      const self = this;
      self.row = row;
      self.inObj.remark = null;
      self.inDoing = false;
      self.inDF = true;
    },
    inSubmit() {
      const self = this;
      self.inDoing = true;
      RentItem.in(self.row.id, self.inObj).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.stockInSuccess"),
            type: "success",
          });
          self.handleClick();
        } else {
          self.sysError();
        }
        self.inDoing = false;
        self.inDF = false;
      });
    },
    //
    buildTableData(records) {
      let rs = [];
      records.forEach((bg) => {
        bg.items.forEach((item) => {
          let obj = item;
          Vue.set(obj, "_serialNo", bg.serialNo);
          Vue.set(obj, "_customerId", bg.customerId);
          Vue.set(obj, "_customerName", bg.customerName);
          Vue.set(obj, "_customerPhone", bg.customerPhone);
          Vue.set(obj, "_packageName", bg.packageName);
          Vue.set(obj, "_remark", bg.remark);
          Vue.set(obj, "_ownerName", bg.ownerName);
          Vue.set(obj, "_shopName", bg.shopName);
          Vue.set(obj, "_createAt", bg.createAt);
          Vue.set(obj, "_items", bg.items);
          rs.push(obj);
        });
      });
      return rs;
    },
    buildMergeCells(records) {
      let mcs = [];
      for (let i = 0, rowIdx = 0; i < records.length; i++) {
        mcs.push({
          row: rowIdx, //行
          col: 0,
          rowspan: records[i].items.length, //跨行
          colspan: 1, //跨列
        });
        rowIdx = rowIdx + records[i].items.length;
      }
      return mcs;
    },
    mergeMethod({ rowIndex, columnIndex }) {
      const mergeCells = this.mergeCells;
      for (let mIndex = 0; mIndex < mergeCells.length; mIndex++) {
        const { row, col, rowspan, colspan } = mergeCells[mIndex];
        if (row === rowIndex && col === columnIndex) {
          return { rowspan, colspan };
        }
        if (
          rowIndex >= row &&
          rowIndex < row + rowspan &&
          columnIndex >= col &&
          columnIndex < col + colspan
        ) {
          return { rowspan: 0, colspan: 0 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },

    cellStyle({ row, rowIndex, column, columnIndex }) {
      if (columnIndex == 0) {
        return {
          "vertical-align": "top",
        };
      }
      return "";
    },
  },
};
</script>
<style scoped>
</style>